import { call, put, takeEvery } from 'redux-saga/effects'
import { FetchPaymentMethod } from 'src/constants/actionTypes'
import { ApiService, callClientSecureApi, callContractorPortalSecureApi } from './api/callApi'
import { AsyncAction } from 'src/utils/reduxUtils'
import { Endpoints } from 'src/constants/endpoints'
import { DriverPaymentMethod } from 'src/interfaces/paymentMethod'
import { getApiErrorMessage } from 'src/utils/errorHandlers'

interface FetchPaymentMethodPayload {
  flow: 'client' | 'contractorPortal'
}

function* onFetchPaymentMethod(
  action: AsyncAction<FetchPaymentMethodPayload, DriverPaymentMethod>,
) {
  try {
    const { flow } = action.payload

    let apiCall

    if (flow === 'client') {
      apiCall = callClientSecureApi
    } else if (flow === 'contractorPortal') {
      apiCall = callContractorPortalSecureApi
    } else {
      throw new Error('No auth token available')
    }

    const { payload }: { payload: DriverPaymentMethod } = yield call(
      apiCall,
      Endpoints.FetchPaymentMethod,
      {
        method: 'GET',
        apiService: ApiService.Paraworks,
      },
    )

    yield put(FetchPaymentMethod.success(payload))

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    const errorMessage = getApiErrorMessage(err, 'Failed to fetch settlement method')

    yield put(FetchPaymentMethod.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* fetchPaymentMethodSaga() {
  yield takeEvery(FetchPaymentMethod.type.REQUEST, onFetchPaymentMethod)
}
